import JQueryView, { on } from '../../../common/views/jqueryView';

export default class AboutCompanyPageView extends JQueryView {
  // 状態
  private scrollHandler?: () => void;
  private $slider?: JQuery;

  constructor() {
    super('#sb-site');

    this.initScrollHandler();
    this.initCustomerVoiceSlider();

    // Turbolinksでページ遷移時にクリーンアップ
    document.addEventListener('turbolinks:before-cache', () => {
      this.destroy();
    });
  }

  // ===============================
  // スクロール連動
  // ===============================
  private initScrollHandler(): void {
    const $floatingInview = $('.js-floating-inview');
    if (!$floatingInview.length) return;

    this.scrollHandler = () => {
      if (window.scrollY > 100) {
        $floatingInview.addClass('is-active');
      } else {
        $floatingInview.removeClass('is-active');
      }
    };

    $(window).on('scroll', this.scrollHandler);
  }

  // ===============================
  // スライダー(slick)
  // ===============================
  private initCustomerVoiceSlider(): void {
    this.$slider = $('.js-slick-customer-voice');
    if (!this.$slider.length) return;

    // 既に初期化されている場合はスキップ
    if (this.$slider.hasClass('slick-initialized')) {
      return;
    }

    this.$slider.slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToScroll: 1,
      variableWidth: true,

      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick',
        },
      ],
    });
  }

  // ===============================
  // スマホ時のもっと見る
  // ===============================
  @on({ event: 'click', selector: '.js-click-showmore' })
  customerVoiceShowMore(e: JQuery.ClickEvent) {
    const $btn = $(e.currentTarget);
    const $accordion = $('.js-accordion');

    if ($accordion.hasClass('is-closed')) {
      $btn.text('表示を減らす');
      $accordion.removeClass('is-closed');
    } else {
      $btn.text('さらに表示する');
      $accordion.addClass('is-closed');
    }
  }

  // ===============================
  // クリーンアップ
  // ===============================
  destroy() {
    // スクロールハンドラを解除
    if (this.scrollHandler) {
      $(window).off('scroll', this.scrollHandler);
    }

    // slickを破棄
    if (this.$slider?.hasClass('slick-initialized')) {
      this.$slider.slick('unslick');
    }

    super.destroy();
  }
}
